module.exports = __webpack_public_path__ + "assets/img/thumb-down.7851fb5f.svg";